<template>
  <div />
</template>

<script>
export default {
  name: 'RequestEngine',

  props: {
    url: {
      type: String,
      required: true,
    },

    options: {
      type: Object,
      required: true,
    },

    stopRequests: {
      type: Boolean,
      default: false,
    },

    shouldRequestOnMounted: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      debounce: 0,
      debounceTimer: null,
      busy: false,
    };
  },

  computed: {
    params() {
      const params = {};
      Object.entries(this.options).forEach(([key, value]) => {
        if (value.value !== false) {
          params[key] = value.value;
        }
      });
      return params;
    },
  },

  watch: {
    options(newVal, oldVal) {
      if (newVal) {
        this.setDebounce(newVal, oldVal);
        clearTimeout(this.debounceTimer);
        if (!this.stopRequests) {
          this.debounceTimer = setTimeout(() => {
            this.debounce = 0;
            if (!this.busy) {
              this.request();
            }
          }, this.debounce);
        }
      }
    },
  },

  mounted() {
    if (this.shouldRequestOnMounted) {
      this.request();
    }
  },

  methods: {
    setDebounce(newVal, oldVal) {
      let maxDebounce = 0;
      Object.keys(newVal).forEach((key) => {
        if (oldVal[key] && newVal[key].value !== oldVal[key].value && newVal[key].debounce > maxDebounce) {
          maxDebounce = newVal[key].debounce;
        }
      });
      this.debounce = maxDebounce;
    },

    request() {
      this.busy = true;
      this.$emit('set-busy', this.busy);
      this.$axios.get(this.url, { params: this.params })
        .then(({ data }) => {
          this.$emit('response', data);
          this.busy = false;
          this.$emit('set-busy', this.busy);
        })
        .catch((error) => {
          this.busy = false;
          this.$emit('set-busy', this.busy);
          throw new Error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
